<template>
  <div class="min-h-screen">
    <main class="max-w-[1300px] m-auto py-4 px-2 sm:px-4">
      <section class="py-10 px-6 text-center">
        <MobiusLogo to="/home" class="block w-fit mt-10 mb-8 mx-auto" />
        <h2 class="text-4xl mb-4 font-bold text-custom-blue">
          EFICIENCIA EN APRENDIZAJE MATEMÁTICO
        </h2>
        <h2 class="text-4xl mb-4 font-medium">MÉTODO MOBIUS VERSIÓN PREMIUM</h2>
        <p class="mb-4 text-center sm:px-0 md:px-0 lg:px-72">
          Mobius ofrece un exclusivo método de tres pasos diseñado para
          maximizar la eficiencia en el aprendizaje de matemáticas. Este enfoque
          único está disponible en nuestra versión Premium.
        </p>
      </section>

      <section
        class="bg-[#111314] py-10 rounded-3xl shadow-sm px-8 pb-9 pt-14 mb-20 text-white"
      >
        <div class="flex flex-col md:flex-row gap-7">
          <div class="flex-1 relative">
            <h3 class="text-center text-3xl font-bold mb-8">1. MOTIVACIÓN</h3>
            <img
              class="lg:absolute rounded-3xl"
              src="@/assets/images/walking.png"
              alt=""
            />
          </div>

          <div class="flex-1">
            <p class="font-thin text-justify">
              En esta etapa, los estudiantes asisten a 8 clases en vivo con
              ingenieros de empresas líderes como Google, Amazon, Tesla,
              Microsoft, Apple y SnapChat. En estas sesiones se exploran
              aplicaciones matemáticas en diversos campos que suelen ser
              desconocidos pero increíblemente inspiradores para los estudiantes
              (Ver curriculum completo al final).
            </p>

            <div class="flex justify-center gap-5 logos">
              <Icon
                icon="devicon-plain:google-wordmark"
                width="135"
                height="135"
              />
              <Icon icon="f7:logo-microsoft" width="135" height="135" />
              <Icon icon="lineicons:amazon" width="135" height="135" />
            </div>
            <div class="flex justify-center gap-5">
              <Icon icon="bi:apple" width="50" height="50" />
              <Icon icon="simple-icons:tesla" width="50" height="50" />
            </div>
          </div>

          <div class="flex-1">
            <p class="font-medium">
              <strong>Formato:</strong> Conferencias virtuales en vivo.
            </p>
            <p class="font-medium">
              <strong>Frecuencia:</strong> Hay una sesión cada dos semanas
              durante 4 meses.
            </p>
            <p class="mb-3 font-medium">
              <strong>Duración total:</strong> 4 meses.
            </p>
            <p class="font-thin text-justify">
              Estas clases están diseñadas para mostrar el impacto real de las
              matemáticas en el mundo profesional y despertar la curiosidad de
              los estudiantes.
            </p>
          </div>
        </div>
      </section>

      <section class="flex flex-col md:flex-row gap-10 mb-20">
        <div class="flex-1 bg-custom-blue text-white rounded-3xl shadow-sm p-7">
          <h3 class="font-bold mb-5 text-2xl">2. DESARROLLO DEL PENSAMIENTO</h3>

          <p class="mb-3 font-thin text-justify">
            Una vez motivados, los estudiantes tienen 2 sesiones con un
            ingeniero de matemáticas aplicadas que se enfocará en ejercicios
            para el desarrollo del pensamiento matemático (Ver detalles del
            currículum al final). El objetivo es cultivar una mentalidad
            matemática sólida y adaptable.
          </p>

          <p><strong>Formato:</strong> Conferencias virtuales en vivo.</p>
          <p>
            <strong>Frecuencia:</strong> Hay una sesión nueva cada dos semanas
            durante 1 mes.
          </p>
          <p><strong>Duración total:</strong> 1 mes.</p>
        </div>

        <div class="flex-1 bg-custom-blue text-white rounded-3xl shadow-sm p-7">
          <h3 class="font-bold mb-5 text-2xl">3. PROFUNDIZACIÓN</h3>

          <p class="mb-3 font-thin text-justify">
            Tras la fase de motivación y desarrollar una base de pensamiento
            matemático, los estudiantes avanzan a cursos de especialización.
            Estos cursos buscan acelerar el aprendizaje en temas clave para
            completar con éxito la educación secundaria y preparar a los
            estudiantes para los retos de la educación superior.
          </p>

          <p>
            <strong>Formato:</strong> Cursos en la plataforma disponibles 24/7.
          </p>
          <p>
            <strong>Frecuencia:</strong> El estudiante puede realizar los cursos
            a su ritmo y puede acceder a ellos las veces que considere.
          </p>
          <p>
            <strong>Duración total:</strong> El estudiante tiene acceso
            ilimitado a los cursos gratis y premium de la plataforma durante 1
            año.
          </p>
        </div>
      </section>

      <section class="flex flex-col md:flex-row mb-20">
        <div class="flex-1">
          <img
            class="rounded-3xl w-90"
            src="@/assets/images/meeting.png"
            alt=""
          />
        </div>
        <div class="flex-1 pt-8 px-3">
          <h3 class="font-medium mb-5 text-6x1 leading-none text-custom-blue">
            SOBRE <br />
            NOSOTROS
          </h3>
          <p class="mb-5 text-justify">
            <strong>Mobius</strong> es un plataforma educativa virtual que usa
            técnicas de Machine learning en conjunto con técnicas de psicología
            educativa para proporcionar contenido y orientación adaptados a las
            necesidades de cada estudiante.
          </p>
          <h4 class="mb-3 font-medium text-2xl text-custom-blue">MISIÓN</h4>
          <p class="text-justify">
            <strong>Mobius</strong> tiene como misión desarrollar herramientas
            didácticas y tecnológicas que faciliten el acceso al conocimiento
            científico, así como promover y fomentar este conocimiento como
            recurso fundamental para el desarrollo social y económico.
          </p>
        </div>
      </section>

      <section class="py-10 px-24 text-center mb-20 sm:mb-5">
        <h2 class="mb-8 tracking-widest text-custom-blue text-4xl font-bold">
          FUNDADORES
        </h2>
        <p class="mb-4 px-8">
          Carlos Velásquez y John Hurtado son los fundadores de Mobius. Ambos
          aportan una combinación única de experiencia profesional y formación
          académica. Carlos es ingeniero matemático y magíster en ciencias
          financieras de la Universidad EAFIT, con una maestría en Information
          Systems Management de Carnegie Mellon University. Cuenta con 13 años
          de experiencia en ciencia de datos y machine learning en empresas como
          Amazon y SnapChat. John, por su parte, es filósofo de la Universidad
          de Antioquia e ingeniero administrador de la Universidad Nacional, con
          un PhD en estudios culturales y literarios latinoamericanos de Ohio
          State University y cinco años de experiencia en educación.
        </p>
      </section>

      <section class="py-10 px-6">
        <h2
          class="mb-8 tracking-widest text-custom-blue text-4xl font-bold text-center"
        >
          CURRÍCULUM DETALLADO
        </h2>
        <h3 class="text-4xl font-bold">SESIONES DE LA FASE MOTIVACIÓN</h3>
        <div class="flex flex-col md:flex-row gap-4">
          <div class="flex-1 p-7">
            <div class="mb-5">
              <h3 class="font-bold text-2xl mb-4">
                1. APLICACIONES GENERALES I
              </h3>
              <p class="text-justify mb-4">
                En esta sesión, un matemático aplicado de Snapchat nos muestra
                cómo las matemáticas desempeñan un papel fundamental en diversas
                áreas como los negocios, el deporte y la psicología. Se abordan
                temas como análisis de datos y modelado estadístico,
                herramientas clave en la toma de decisiones empresariales para
                optimizar estrategias y predecir tendencias.
              </p>
              <p class="text-justify">
                En el deporte, se exploran modelos de rendimiento y
                probabilidad, útiles para mejorar tácticas y evaluar el
                desempeño de los atletas. En psicología, se revisan métodos de
                análisis de patrones de comportamiento y modelos de predicción
                que ayudan a comprender mejor las conductas.
              </p>
            </div>

            <div class="mb-5">
              <h3 class="font-bold text-2xl mb-4">
                2.APLICACIONES GENERALES II
              </h3>
              <p class="text-justify">
                En esta sesión, profundizaremos en los conceptos introducidos
                anteriormente, explorando su aplicación en diversas áreas como
                las finanzas, los videojuegos, la medicina y el derecho, entre
                otros campos de interés general. A través de ejemplos prácticos
                y casos reales, descubriremos cómo estas ideas pueden
                transformarse en soluciones innovadoras y de impacto en
                distintos sectores.
              </p>
            </div>

            <div class="mb-5">
              <h3 class="font-bold text-2xl mb-4">3. AMAZON GO</h3>
              <p class="text-justify">
                En esta sesión, un ingeniero de Amazon explica cómo las
                matemáticas y la tecnología se combinan para hacer posible el
                funcionamiento de las tiendas Amazon Go, donde los clientes
                pueden entrar, tomar los productos que necesitan y salir sin
                pasar por cajas de pago tradicionales. Se exploran conceptos
                como visión por computadora, algoritmos de seguimiento de
                movimiento y detección de objetos, así como modelos matemáticos
                y probabilísticos que permiten a los sistemas identificar con
                precisión los productos tomados y las personas en la tienda.
              </p>
            </div>

            <div class="mb-5">
              <h3 class="font-bold text-2xl mb-4">4. TESLA</h3>
              <p class="text-justify">
                En esta sesión, un ingeniero de Tesla explica cómo las
                matemáticas son fundamentales para desarrollar vehículos
                autónomos. Se exploran temas como el procesamiento de señales,
                el cálculo de trayectorias y la optimización, que permiten al
                automóvil detectar obstáculos, trazar rutas seguras y responder
                en tiempo real a las condiciones de la carretera. Además, se
                revisan modelos matemáticos de machine learning y visión por
                computadora que ayudan al vehículo a "entender" su entorno,
                garantizando una experiencia de conducción autónoma segura y
                eficiente.
              </p>
            </div>
          </div>

          <div class="flex-1 p-7">
            <div class="mb-5">
              <h3 class="font-bold text-2xl mb-4">5. GOOGLE MAPS</h3>
              <p class="text-justify">
                En esta sesión, un ingeniero de Google explica cómo las
                matemáticas son esenciales para el funcionamiento de Google
                Maps. Se abordan temas como teoría de grafos y algoritmos de
                búsqueda óptima, que permiten calcular las rutas más rápidas
                entre dos puntos. También se exploran modelos de optimización y
                predicción que consideran factores como el tráfico en tiempo
                real, la distancia y el tiempo estimado de llegada. Además, se
                discuten conceptos de análisis espacial y procesamiento de datos
                geográficos, que permiten mejorar la precisión de la navegación
                y las recomendaciones de rutas para millones de usuarios en todo
                el mundo.
              </p>
            </div>

            <div class="mb-5">
              <h3 class="font-bold text-2xl mb-4">6. SNAPCHAT - SPECTACLES</h3>
              <p class="text-justify">
                En esta sesión, un ingeniero de Snapchat nos explica cómo las
                matemáticas son fundamentales en el diseño y desarrollo de las
                Spectacles, las gafas inteligentes de Snapchat. Aprenderemos
                cómo se aplican conceptos de geometría, álgebra lineal y
                optimización para diseñar lentes de alta precisión y estructuras
                ergonómicas que ofrecen comodidad y estilo. También
                descubriremos el papel del procesamiento de señales y las
                transformadas matemáticas en la captura y procesamiento de
                imágenes y videos en tiempo real, además de cómo los algoritmos
                avanzados mejoran la experiencia del usuario.
              </p>
            </div>

            <div class="mb-5">
              <h3 class="font-bold text-2xl mb-4">7. MICROSOFT - XBOX</h3>
              <p class="text-justify">
                En esta sesión, explicaremos cómo conceptos como álgebra lineal,
                cálculo y teoría de grafos son esenciales para desarrollar los
                videojuegos de Microsoft, desde gráficos 3D realistas en Xbox
                hasta simulaciones y comportamientos inteligentes en mundos
                virtuales.
              </p>
            </div>

            <div class="mb-5">
              <h3 class="font-bold text-2xl mb-4">8. META - INSTAGRAM</h3>
              <p class="text-justify">
                En esta sesión, estudiamos cómo conceptos como álgebra lineal,
                estadística y optimización son fundamentales para el
                funcionamiento de Instagram, desde la personalización del feed y
                las recomendaciones de contenido hasta los filtros y efectos
                visuales. Descubriremos cómo algoritmos matemáticos impulsan
                herramientas como la detección de rostros, la realidad aumentada
                en filtros y la segmentación de audiencias para mejorar la
                experiencia del usuario y conectar a millones de personas en
                todo el mundo.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-10 px-6">
        <h3 class="text-4xl font-bold">
          SESIONES DE LA FASE <br />
          DE PENSAMIENTO MATEMÁTICO
        </h3>

        <div class="flex flex-col md:flex-row gap-4">
          <div class="flex-1 p-7">
            <div class="mb-5">
              <h3 class="font-bold text-2xl mb-4">
                1. PENSAMIENTO MATEMÁTICO 1
              </h3>
              <p class="text-justify">
                En esta sesión exploraremos cómo los números, patrones y
                estructuras lógicas nos ayudan a resolver problemas. A través de
                actividades prácticas y ejercicios analíticos, desarrollaremos
                habilidades de razonamiento lógico y abstracción. Al finalizar,
                los participantes contarán con herramientas clave para abordar
                desafíos matemáticos con mayor confianza y claridad.
              </p>
            </div>
          </div>

          <div class="flex-1 p-7">
            <div>
              <h3 class="font-bold text-2xl mb-4">
                2. PENSAMIENTO MATEMÁTICO 2
              </h3>
              <p class="text-justify">
                En esta sesión, profundizaremos en el uso del razonamiento
                lógico y la resolución estructurada de problemas complejos.
                Exploraremos patrones avanzados, estrategias de descomposición
                de problemas y técnicas para optimizar el proceso de análisis
                matemático. A través de ejercicios prácticos y casos aplicados,
                los participantes fortalecerán su capacidad para abordar
                desafíos con mayor precisión y creatividad, consolidando así las
                bases del pensamiento matemático adquirido en la primera sesión.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import MobiusLogo from "@/components/MobiusLogo.vue";

export default {
  name: "Infographic",
  components: {
    Icon,
    MobiusLogo,
  },
};
</script>

<style scope>
.font-thin {
  font-weight: 100;
}

.logos {
  height: 110px;
  margin-top: -30px;
}

.rounded-3xl {
  border-radius: 1.5rem;
}

.bg-custom-blue {
  background-color: #0279fe;
}

.text-custom-blue {
  color: #0279fe;
}

.pt-8 {
  padding-top: 2rem;
}

.text-6x1 {
  font-size: 3.75rem;
}

.gap-10 {
  gap: 2.5rem;
}

.w-30 {
  width: 30%;
}

.w-90 {
  width: 91.666667%;
}

.tracking-widest {
  letter-spacing: 0.7em;
}
</style>
